import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import './Select.less';

export default class Select extends React.Component {
    static displayName = 'Assets.Input.Select';
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        onChange: PropTypes.func,
        placeholder: PropTypes.string,
    };
    static defaultProps = {
        children: [],
        className: '',
        placeholder: '',
        onChange: () => {},
        value: ''
    };

    constructor(props) {
        super(props);
        var defaultValue = 'selected';
        if (this.props.value != null && this.props.value != undefined) {
            defaultValue = this.props.value;
        }
        this.state = {
            value: defaultValue
        };
    }

    onChange(e) {
        this.setState({
            value: e.target.value
        }, this.props.onChange.bind(this, e.target.value));
    }

    render() {
        var classes = classnames(
            this.props.className
        );
        return (
            <span className="dob-select">
                <select className={classes}
                            onChange={this.onChange.bind(this)}
                            value={this.state.value}>
                    {this.props.placeholder && <option value="selected" disabled>{this.props.placeholder}</option>}
                    {this.props.children}
                </select>
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/ConsentsLoginModal/Select/index.jsx